import authSlice from "./AuthSlice";
import CopingSlice from "./CopingSlice";
import ProviderSlice from "./ProviderSlice";

export const rootReducer = {
  Auth: authSlice,
  Provider: ProviderSlice,
  Coping: CopingSlice,
};
